import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'ecp-switch',
    templateUrl: './map-switch.component.html',
    styleUrls: ['./map-switch.component.css']
})
export class MapSwitchComponent implements OnInit {

    @Input() customPosition: object;
    @Input() switchArray: Array<any>;
    selectId = 0;//å½åéä¸­çéé¡¹.
    /*
      switchArray = [{
        "name": "æä½",
        "icon": "icon-operation"
      }, {
        "name": "å±ç¤º",
        "icon": "icon-demonstration"
      }, {
        "name": "å±ç¤ºäº",
        "icon": "icon-demonstration"
      }, {
        "name": "å±ç¤ºä¸",
        "icon": "icon-demonstration"
      }];
    */

    select(i) {
        this.selectId = i;
        //console.log("å½åéä¸­" + i + "#######" + this.switchArray[i].name);
    }

    constructor() {
    }

    ngOnInit() {
    }

}
